module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-layout', {
    staticClass: "trust-form-layout"
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("激活委托")]), _vm._v(" "), _c('div', {
    staticClass: "table_area",
    attrs: {
      "slot": "main-content"
    },
    slot: "main-content"
  }, _vm._l((_vm.activebox), function(item, index) {
    return _c('div', {
      staticClass: "item-box"
    }, [_c('table', [_c('thead', [_c('tr', [_c('td', {
      attrs: {
        "width": "100"
      }
    }, [_vm._v("批次号")]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "260"
      }
    }, [_vm._v("物料名称")]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "100"
      }
    }, [_vm._v("品项")]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "100"
      }
    }, [_vm._v("品牌")]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "100"
      }
    }, [_vm._v("机型")]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "100"
      }
    }, [_vm._v("模块")]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "100"
      }
    }, [_vm._v("数量")]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "180"
      }
    }, [_vm._v("委托时长")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("\n              " + _vm._s(item.ProductCode) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(item.ProductName)), _c('br'), _vm._v("\n              物料编码：" + _vm._s(item.ProductCode) + "\n            ")]), _vm._v(" "), _c('td', [_c('el-tag', {
      attrs: {
        "type": _vm._f("ConditionColor")(item.ConditionName)
      }
    }, [_vm._v(_vm._s(item.ConditionName))])], 1), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(item.ProductBrandName) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(item.ProductModelName) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(item.ProductModuleName) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(item.Quantity) + "\n            ")]), _vm._v(" "), _c('td', [_c('el-select', {
      staticClass: "form-input",
      attrs: {
        "placeholder": "请选择委托时长"
      },
      model: {
        value: (item.TrustTime),
        callback: function($$v) {
          item.TrustTime = $$v
        },
        expression: "item.TrustTime"
      }
    }, _vm._l((_vm.TrustTimes), function(t) {
      return _c('el-option', {
        key: t.value,
        attrs: {
          "label": t.label,
          "value": t.value
        }
      })
    }))], 1)])])]), _vm._v(" "), _c('el-button', {
      staticClass: "delete-btn",
      nativeOn: {
        "click": function($event) {
          _vm.deleteItem(index, item)
        }
      }
    }, [_vm._v("X")])], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "sumbit_box",
    attrs: {
      "slot": "sumbit_box"
    },
    slot: "sumbit_box"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.cancel($event)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.sumbit($event)
      }
    }
  }, [_vm._v("提交并等待客服联系")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-706fb237"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Inventory/TrustActivePage.vue
// module id = 750
// module chunks = 0